import type { ErrorHandler } from '@angular/core';
import { Injectable } from '@angular/core';
import { clientLogger } from '../logger/client.logger';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const original = (error as { ngOriginalError?: Error })?.ngOriginalError;
    const normalized =
      original ?? (error instanceof Error ? error : new Error(String(error)));

    // clientLogger.error forwards to Sentry (captureException) when an error is
    clientLogger.error('Global error handler caught', { error: normalized });
  }
}
